var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsimFeaturedIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_3039)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_309_3039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9292 32.1232C66.8527 33.7391 66.3403 34.6255 65.2906 35.1442C64.1871 35.6897 63.1395 35.5017 62.2159 34.7247C61.162 33.8403 60.1826 32.863 59.0957 32.024C47.1606 22.8123 30.2993 23.7029 19.3767 34.1152C18.5254 34.9272 17.6451 35.6277 16.3826 35.3942C15.2875 35.1917 14.5188 34.5574 14.1592 33.4746C13.7687 32.2968 14.1159 31.305 14.9651 30.4681C17.9303 27.5401 21.3005 25.1928 25.0715 23.4157C38.6453 17.0246 54.9796 19.7645 65.7038 30.2759C66.3051 30.8648 66.6564 31.7058 66.9271 32.1232H66.9292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0112 30.9903C47.2495 31.1081 53.0993 33.3997 57.9469 38.0841C58.4945 38.613 58.9036 39.4437 59.0482 40.1958C59.2776 41.3902 58.6536 42.3428 57.5708 42.8924C56.4467 43.4648 55.3867 43.2685 54.4011 42.4833C53.1117 41.4584 51.8843 40.3198 50.4812 39.4768C43.0796 35.0259 33.8184 35.9475 27.3921 41.6898C27.109 41.9419 26.8362 42.2043 26.5449 42.4461C25.27 43.5061 23.6066 43.4503 22.5486 42.318C21.4989 41.1959 21.5237 39.483 22.6767 38.3196C24.9559 36.0219 27.6028 34.2551 30.5846 32.9906C33.7605 31.6433 37.0811 31.0007 41.0112 30.9883V30.9903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4925 41.8242C44.2801 41.8821 47.5904 43.1839 50.3696 45.806C51.6631 47.0272 51.8057 48.7464 50.7188 49.9428C49.6174 51.1558 47.954 51.1764 46.5737 49.9965C42.658 46.645 38.2299 46.6326 34.3596 49.9635C32.9442 51.1826 31.2354 51.1578 30.1381 49.9056C29.0574 48.672 29.2537 46.9549 30.6196 45.6986C33.4029 43.1405 36.6905 41.8676 40.4904 41.8242H40.4925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6987 56.2025C36.707 54.1424 38.3642 52.4666 40.4161 52.4397C42.4948 52.4149 44.2078 54.1341 44.2016 56.2376C44.1954 58.2957 42.5361 59.9736 40.4842 60.0004C38.4055 60.0273 36.6925 58.306 36.7008 56.2025H36.6987Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_3039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_309_3039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.929,
    height: 40,
    fill: "white",
    transform: "translate(14 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsimFeaturedIcon1);
export default __webpack_public_path__ + "static/media/esim_featured_icon_1.0b38644bc64f8c7e506b8ebc0c8090da.svg";
export { ForwardRef as ReactComponent };